import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useMarco, RUTA_INICIO } from './MarcoContext';
import Icono, { nombreCarpeta } from './Icono';

/* Barra superior: dónde estoy (carpeta › pantalla), favorito de la pantalla,
   «Ir a…» (Ctrl+K), ayuda de teclado (?), pantalla completa y la hora. */

/* nombres para las pantallas que no salen en el menú del usuario (el nombre del menú manda) */
const titulos = Object.fromEntries(Object.entries({
  [RUTA_INICIO]: 'Inicio', '/Examenana': 'Exámenes y análisis', '/Labordenpago': 'Pagos de órdenes',
  '/OrderPinCapture': 'Consulta de resultados por PIN', '/RepAnexo': 'Reporte de anexos', '/DescargarJSON': 'Descargar JSON',
  '/InterfazRuby': 'Interfaz Ruby (hemogramas)', '/InterfazFus2000': 'Interfaz FUS 2000 (orinas)', '/Interfaces': 'Interfaces',
  '/Labnormal': 'Valores normales', '/Lista': 'Lista de trabajo', '/Consultav3': 'Consulta de trabajo (V3)', '/Zbi': 'Tablero BI',
  '/Uploadimages': 'Carga de imágenes', '/Usupendientes': 'Usuarios pendientes', '/Logcaja': 'Recibos de caja',
  '/Ipsconsec': 'Consecutivos IPS', '/Labdepends': 'Dependencias', '/Lablistas': 'Listas de precios', '/Labseccion': 'Secciones',
  '/Labvalores': 'Valores de referencia', '/Tipomuestras': 'Tipos de muestra', '/Undnegocios': 'Unidades de negocio',
  '/Roleopcion': 'Opciones por rol', '/Usuariorole': 'Roles por usuario', '/Reglasimp': 'Reglas de impresión',
  '/Combos': 'Combos', '/Combosdet': 'Detalle de combos', '/Bonosreyfals': 'Bonos Rey-Fals', '/Consultafacturas': 'Consulta de facturas',
  '/Entregares': 'Entrega de resultados', '/Mediospago': 'Medios de pago', '/MedioDePagos': 'Medios de pago',
  '/Examenemp': 'Exámenes por empresa', '/Labempresas': 'Empresas', '/Labtarifas': 'Tarifas', '/Ordenlab': 'Ingreso de orden',
  '/Pacientesing': 'Ingreso de pacientes', '/Pacientes': 'Pacientes', '/Medicos': 'Médicos', '/Ocupaciones': 'Ocupaciones',
  '/Vinculaciones': 'Vinculaciones', '/Diagnosticos': 'Diagnósticos', '/CargaImagenS3': 'Carga de imagen', '/Rips': 'RIPS',
  '/Cartera': 'Cartera', '/Facturacion': 'Facturación', '/Consulta': 'Consulta de órdenes', '/Tracking': 'Seguimiento de muestras',
  '/Resultados': 'Resultados', '/Agencias': 'Agencias', '/Feriados': 'Feriados', '/Unidades': 'Unidades', '/Opciones': 'Opciones',
  '/Roles': 'Roles', '/Usuarios': 'Usuarios', '/Landsticker': 'Impresión de stickers', '/Funnel': 'Funnel de exámenes',
  '/Consultadep': 'Consulta de dependencias', '/Desfirmar': 'Quitar firma de exámenes', '/Cambiospac': 'Cambio de identificación del paciente', '/Deps': 'Departamentos y ciudades',
}).map(([k, v]) => [k.toLowerCase(), v]));

const nombreDesdeRuta = (path) => {
  const limpio = decodeURIComponent(path.replace(/^\/+/, ''));
  if (!limpio) return 'Inicio';
  return titulos[path.toLowerCase()] || limpio.replace(/([a-z])([A-Z])/g, '$1 $2');
};

export default function Topbar() {
  const location = useLocation();
  const { opcionActual, esFavorito, alternarFavorito, abrirPaleta } = useMarco();
  const [ahora, setAhora] = useState(new Date());

  useEffect(() => {
    const id = setInterval(() => setAhora(new Date()), 30000);
    return () => clearInterval(id);
  }, []);

  const titulo = opcionActual ? opcionActual.nombre : nombreDesdeRuta(location.pathname);
  const carpeta = opcionActual ? opcionActual.carpeta : null;
  const fav = opcionActual ? esFavorito(opcionActual.ruta) : false;

  // título de la pestaña del navegador
  useEffect(() => { document.title = `${titulo} · Symedic`; }, [titulo]);

  const pantallaCompleta = () => {
    try {
      if (document.fullscreenElement) document.exitFullscreen();
      else document.documentElement.requestFullscreen();
    } catch (e) { /* el navegador no lo permite */ }
  };

  return (
    <header className="sym-superior">
      <div className="sym-superior__titulo">
        <nav className="sym-migas" aria-label="Ubicación">
          <span>Symedic</span>
          {carpeta && <><Icono nombre="flecha" tam={12} /><span>{nombreCarpeta(carpeta)}</span></>}
        </nav>
        <div className="sym-superior__nombre">
          <h1>{titulo}</h1>
          {opcionActual && (
            <button
              type="button"
              className={`sym-fav${fav ? ' marcado' : ''}`}
              onClick={() => alternarFavorito(opcionActual.ruta)}
              title={fav ? 'Quitar de favoritos (Ctrl+D)' : 'Agregar a favoritos (Ctrl+D)'}
              aria-pressed={fav}
              aria-label="Favorito"
            >
              <Icono nombre="estrella" tam={16} />
            </button>
          )}
        </div>
      </div>

      <button type="button" className="sym-irA" onClick={abrirPaleta} title="Buscar una pantalla o acción (Ctrl+K)">
        <Icono nombre="buscar" tam={16} />
        <span>Ir a una pantalla o acción…</span>
        <kbd className="sym-kbd">Ctrl K</kbd>
      </button>

      <div className="sym-superior__acciones">
        <button type="button" className="sym-icono-btn" onClick={() => window.dispatchEvent(new Event('sym:ayuda-teclado'))} title="Atajos de teclado (?)" aria-label="Atajos de teclado">
          <Icono nombre="teclado" tam={18} />
        </button>
        <button type="button" className="sym-icono-btn" onClick={pantallaCompleta} title="Pantalla completa" aria-label="Pantalla completa">
          <Icono nombre="pantallaCompleta" tam={17} />
        </button>
        <div className="sym-superior__fecha" title={ahora.toLocaleDateString('es-CO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}>
          <strong>{ahora.toLocaleTimeString('es-CO', { hour: '2-digit', minute: '2-digit' })}</strong>
          <span>{ahora.toLocaleDateString('es-CO', { weekday: 'short', day: 'numeric', month: 'short' })}</span>
        </div>
      </div>
    </header>
  );
}
